import LoadingDialog from 'components/loading-dialog/loading-dialog';

export default LoadingDialog;
